import React, { Component } from "react";
import { 
    Button,
    Intent,
    Card, 
    Tag,
    FormGroup,
    InputGroup,
    Tooltip,
    Popover,
    Classes,
    TextArea,
    PopoverInteractionKind,
    Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import { EacAuthenticatedGetFetch, EacAuthenticatedPutFetch, EacAuthenticatedPostFetchWithResult } from "../../utils/ExternalAccessControlAuthenticatedFetch";
import i18next from "i18next";




export default class PrestoParkPage extends Component {
    constructor() {
        super();
        this.state = {
            baseUrl: "",
            accessToken: "",
            cityId: "",
            profileId: 0,
            subscriptionForbidden:[],
            checkImmat: "",
            immatPermits:"",
            immatRights:"",
            immatAuth: "",
            openConfigPanel: false
        };        
    }

    componentDidMount() {
        EacAuthenticatedGetFetch('/prestopark/config', (data)=>{
            const ret = {baseUrl: "", accessToken: "", cityId: ""}
            if(data.baseUrl)
                ret.baseUrl = data.baseUrl;
            if(data.accessToken)
                ret.accessToken = data.accessToken;
            if(data.cityId)
                ret.cityId = data.cityId;
            if(data.profileId)
                ret.profileId = data.profileId;
            if(data.subscriptionForbidden)
                ret.subscriptionForbidden = data.subscriptionForbidden;
                        
            this.setState(ret);
        });       
    }
    disableSaveButton(){
        return !(this.state.baseUrl.length > 0 
            &&  this.state.accessToken.length > 0
            &&  this.state.cityId.length > 0);
    }
    saveConfig() {
        EacAuthenticatedPutFetch('/prestopark/config', this.state, (data)=>{

        });
    }
    addNewSubscription(){
        this.setState({subscriptionForbidden: [...this.state.subscriptionForbidden, this.state.newSub], newSub:""});
    }


    disableCheckImmatButton(){
      return this.state.checkImmat?.length > 5? false: true;
    }

    processRequest = async function processRequestAsync(method, url, accessToken){
      return new Promise((res, rej)=>{
        fetch(url, {
          method,
          headers: { Authorization: `Bearer ${accessToken}`}
        })
          .then((response) => {
            //const statusCode = response.status;
            res(response.json());
          })
          .catch(error => {
            console.log(`PrestoPark Request (${url}): ${error.message}`)
            res(error.message);
          });
      });
    }
    processCheckPrestoParkImmat = async function processCheckPrestoParkImmatAsync(){
      this.setState({immatPermits: "", immatRights: ""})
      // let url = this.state.baseUrl + `/parking-permits?vehicleRegistrationPlateIdentifier=${this.state.checkImmat}&cityId=${this.state.cityId}`;
      // const permits = await this.processRequest('GET', url, this.state.accessToken);

      // url = this.state.baseUrl + `/parking-rights?vehicleRegistrationPlateIdentifier=${this.state.checkImmat}&cityId=${this.state.cityId}`;
      // const rights = await this.processRequest('GET', url, this.state.accessToken);
      EacAuthenticatedPostFetchWithResult(`/check`, {
          "typeVehicle": 0,
          "typeSupport": 0,
          "numSupport": this.state.checkImmat.trim(),
          "parkId": 1,
          "deviceEntry": 1,
          "entryDate": Number(Date.now() / 1000)
      }, (status, res)=>{
        this.setState({immatPermits: JSON.stringify(res?.permits, null, 2), immatRights: JSON.stringify(res?.rights, null, 2)});  
          
      });   
    }    
    
    toggleConfigPanel(){
      this.setState({openConfigPanel: !this.state.openConfigPanel});
    }

    processCheckHitachiImmat = async function processCheckImmatAsync(){
      this.setState({immatAuth: ""})
      EacAuthenticatedPostFetchWithResult(`/checkAuth`, {
          "typeVehicle": 0,
          "typeSupport": 0,
          "numSupport": this.state.checkImmat.trim(),
          "parkId": 1,
          "deviceEntry": 1,
          "entryDate": Number(Date.now() / 1000)
      }, (status, res)=>{
        let state = (res.userState ===  1 && res.userStatus !== 2) ? 'can enter': 'not allow';
        const message = res.userStatus === 2 ? res.message: "";
        this.setState({immatAuth: JSON.stringify({state, message}, null, 2)})
        if(res.userState ===  1 && res.userStatus !== 2){
          //remove  database session subscription
          //for the exit workflow
          EacAuthenticatedPostFetchWithResult(`/checkOut`, {
            "typeVehicle": 0,
            "typeSupport": 0,
            "numSupport": this.state.checkImmat.trim(),
            "parkId": 1,
            "deviceEntry": 1,
            "entryDate": Number(Date.now() / 1000),
            "deviceExit" : 1,
            "exitDate":  Number(Date.now() / 1000),
            "amount": 0,
            "vat": 0
          });
        }
          
      })
      
      
    }    
    

    render() {
        return (
          <div>
            {localStorage.getItem('perm_admin') === "true" &&
              <Callout  title={
                <>
                  <Trans>Configuration</Trans> 
                  {" "}
                  <Tooltip
                    content={this.state.openConfigPanel?<Trans>hide</Trans>: <Trans>show</Trans>}
                  >
                    <Button
                      icon={this.state.openConfigPanel?"collapse-all": "expand-all"}
                      intent={Intent.NONE}
                      type="submit"
                      onClick={() => { this.toggleConfigPanel()}}
                      />
                  </Tooltip>
                </>
                } >
                  <div className="flexbox-right">
                    
                  </div>
                  {/* configuration */}
                  {this.state.openConfigPanel &&
                  <>
                    <Card>
                        <form>
                          <FormGroup label={<Trans>external bo url</Trans>} labelFor="ex-bo-url-input">
                            <InputGroup id="ex-bo-url-input"
                              onChange={(ti) => { this.setState({ baseUrl: ti.target.value }); }}
                              value={this.state.baseUrl}
                              intent="normal"
                              type="text"
                            />
                          </FormGroup>
                          <FormGroup label={<Trans>access token</Trans>} labelFor="accessToken-input">
                            <InputGroup
                              id="accessToken-input"
                              type="text"
                              onChange={(ti) => { this.setState({ accessToken: ti.target.value }); }}
                              value={this.state.accessToken}
                              intent="normal"
                            />
                          </FormGroup>
                          <FormGroup label={<Trans>city name</Trans>} labelFor="cityId-input">
                            <InputGroup
                              id="cityId-input"
                              type="text"
                              onChange={(ti) => { this.setState({ cityId: ti.target.value }); }}
                              value={this.state.cityId}
                              intent="normal"
                            />
                          </FormGroup>
                          
                          <FormGroup label={<Trans>profile</Trans>} labelFor="profileId-input">
                            <InputGroup
                              id="profileId-input"
                              type="number"
                              onChange={(ti) => { this.setState({ profileId: ti.target.value }); }}
                              value={this.state.profileId}
                              intent="normal"
                            />
                          </FormGroup>
                          <div  className="flexbox-left">
                          <Trans>subscriptions Forbidden</Trans><br/>
                          
                            <Popover
                                placement="auto"
                                interactionKind={PopoverInteractionKind.HOVER}
                                modifiers={{ arrow: { enabled: true } }}

                                content={
                                    <div style={{ 'padding': '5px' }}>
                                        
                                        <FormGroup label={<Trans>subscription name</Trans>} labelFor="newSub-input">
                                          <InputGroup
                                            id="newSub-input"
                                            type="text"
                                            onChange={(ti) => { this.setState({ newSub: ti.target.value }); }}
                                            value={this.state.newSub}
                                            intent="normal"
                                          />
                                        </FormGroup>
                                      
                                        <Button intent="success" className={Classes.POPOVER_DISMISS} onClick={()=>{this.addNewSubscription()}}><Trans>add</Trans></Button>
                                    </div>
                                }
                            >
                                <Button minimal={false} intent="success"><Trans>add</Trans></Button>
                            </Popover>

                            {this.state.subscriptionForbidden?.map((subs, index) => (
                              <Tag
                                key={index}
                                onRemove={() =>
                                  this.setState({
                                    subscriptionForbidden: this.state.subscriptionForbidden.filter(
                                      (i) => i !== subs
                                    ),
                                  })
                                }
                              >
                                {subs}
                              </Tag>
                            ))}
                          </div> 
                        </form>
                        <div className="flexbox-right">
                          <Button
                              text={<Trans>edit</Trans>}
                              icon="send-to"
                              intent={Intent.WARNING}
                              type="submit"
                              disabled={this.disableSaveButton()}
                              onClick={() => { this.saveConfig()}}
                              />
                        </div>
                    </Card>
                  </>
                  }
              </Callout>
            }
            <Callout  title={<Trans>subscriber number</Trans>}>
              <Card>
                <form>
                  <FormGroup label={<Trans>Licence plate</Trans>} labelFor="ex-presto-checkimmat">
                    <InputGroup id="ex-presto-checkimmat"
                      onChange={(ti) => { this.setState({ checkImmat: ti.target.value }); }}
                      value={this.state.checkImmat}
                      intent="normal"
                      type="text"
                    />
                  </FormGroup>                    
                </form>
              </Card>
            </Callout> 
            <Callout  title={"PrestoPark: " + i18next.t("manage subscribers")}>
              <Card>
                  <div className="flexbox-right">
                    <Button
                        text={<Trans>edit</Trans>}
                        icon="send-to"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={this.disableCheckImmatButton()}
                        onClick={async( ) => { await this.processCheckPrestoParkImmat()}}
                        />
                  </div>
                  <div>
                  <label>request-permits</label>
                  <TextArea
                      style={{width: '100%'}}
                      autoResize={true}
                      maxLength={200}
                      type="text"
                      id="parking-permits"
                      name="parking-permitsDescription"
                      value={this.state.immatPermits}                  
                  />
                  <label>request-rights</label>
                  <TextArea
                      style={{width: '100%'}}
                      autoResize={true}
                      maxLength={200}
                      type="text"
                      id="parking-pights"
                      name="parking-pightsDescription"
                      value={this.state.immatRights}       
                  />
                  </div>
              </Card>
            </Callout>       
            <Callout  title={"Hitachi: " + i18next.t("manage subscribers")}>
              <Card>
                  <div className="flexbox-right">
                    <Button
                        text={<Trans>edit</Trans>}
                        icon="send-to"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={this.disableCheckImmatButton()}
                        onClick={async( ) => { await this.processCheckHitachiImmat()}}
                        />
                  </div>
                  <div>
                  <label>Result</label>
                  <TextArea
                      style={{width: '100%'}}
                      autoResize={true}
                      maxLength={200}
                      type="text"
                      id="parking-permits"
                      name="parking-permitsDescription"
                      value={this.state.immatAuth}                  
                  />
                  </div>
              </Card>
            </Callout>                   
          </div>
        );
    }
}
